import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import type { ReactNode } from "react";

export type PageHeaderBreadcrumb = {
	label: string;
	current?: boolean;
	onClick?: () => void;
};

type PageHeaderProps = {
	title: string;
	description?: string;
	backLabel?: string;
	breadcrumbs?: PageHeaderBreadcrumb[];
	actions?: ReactNode;
	onBack?: () => void;
};

export function PageHeader({
	actions,
	backLabel,
	breadcrumbs,
	description,
	onBack,
	title,
}: PageHeaderProps) {
	return (
		<div className="crm-page-head">
			<div>
				{breadcrumbs?.length ? (
					<nav className="crm-breadcrumb" aria-label="Breadcrumb">
						{breadcrumbs.map((item, index) => {
							const isLast = index === breadcrumbs.length - 1;

							return (
								<span className="crm-breadcrumb-node" key={`${item.label}-${index}`}>
									{item.current || !item.onClick ? (
										<span
											className={item.current ? "crm-breadcrumb-current" : "crm-breadcrumb-item"}
										>
											{item.label}
										</span>
									) : (
										<button type="button" className="crm-breadcrumb-item" onClick={item.onClick}>
											{item.label}
										</button>
									)}
									{isLast ? null : <span className="crm-breadcrumb-sep">/</span>}
								</span>
							);
						})}
					</nav>
				) : null}

				<div className="crm-page-title-row">
					{onBack ? (
						<Button
							type="text"
							icon={<ArrowLeftOutlined />}
							className="crm-back-btn"
							onClick={onBack}
							aria-label={backLabel ?? "Ortga"}
							title={backLabel ?? "Ortga"}
						/>
					) : null}
					<div>
						<h1>{title}</h1>
						{description ? <p>{description}</p> : null}
					</div>
				</div>
			</div>
			{actions ? <div className="crm-page-actions">{actions}</div> : null}
		</div>
	);
}
